import { getBasePositionSet, getBaseSignature } from "selectors/base"
import createModule from "../createModule"
import { getViewType, getSelectedModelId, getMustAggregateFactors, getCurrency, getPortfolioFxHedgeEnabled } from "modules/portfolio-root/selectors/portfolios"
import { getPerformanceFetchStartDate } from "selectors/dates"
import { getPerformanceDetails, getFactorsPerfStartDate } from "./selectors/factors"
import { getFirstDate } from "modules/overview-performance/selectors"
import { VIEW_TYPES } from "helpers/base"
import view from "./view"

export default createModule({
  view,
  externalProps: state => ({
    account: state.global.selected.account,
    portfolioId: state.global.selected.portfolio,
    modelId: getSelectedModelId(state),
    base: getBasePositionSet(state),
    startDate: getFactorsPerfStartDate(state),
    baseSignature: getBaseSignature(state),
    fetchStartDate: getPerformanceFetchStartDate(state),
    viewType: getViewType(state),
    hasAggregatedFactors: getMustAggregateFactors(state),
    currency: getCurrency(state),
    fxHedgeEnabled: getPortfolioFxHedgeEnabled(state),
  }),
  required: ["account", "modelId", "portfolioId", "startDate", "endDate"],
  data: [{
    resource: "factorsPerformance",
    url: ({ modelId, startDate, endDate, hasAggregatedFactors, currency, fxHedgeEnabled }) => {
      if (hasAggregatedFactors) {
        return null
      }
      return {
        id: `${modelId}${startDate}${endDate}${currency}${fxHedgeEnabled}`,
        query: `query ($modelId: String!, $from: Date!, $to: Date!, $currency: Currency) {
          model (id: $modelId) {
            factors(currency: $currency) {
              id,
              name,
              performance(from: $from, to: $to, interval: END_DATE) {
                percentPriceChangeCumulative
              }
            }
          }
        }`,
        variables: {
          modelId,
          from: startDate,
          to: endDate,
          currency,
        },
      }
    },
  }, {
    resource: "axiomaPerformanceDetails",
    as: null,
    url: ({ modelId, portfolioId, endDate, base, baseSignature, fetchStartDate, viewType, currency, fxHedgeEnabled }) => {
      return {
        id: `${modelId}${portfolioId}${fetchStartDate}${endDate}${viewType}${baseSignature}${currency}${fxHedgeEnabled}`,
        query: `query ($modelId: String!, $portfolioId: String!, $from: Date!, $to: Date!, $base: [PositionSetInput]) {
          model (id: $modelId) {
            simulation (positionSet: {
              type: PORTFOLIO,
              id: $portfolioId
            }, from: $from, to: $to, base: $base, interval: END_DATE) {
              performance {
                attribution {
                  factors {
                    id
                    return {
                      cumulativePercent
                    }
                  }
                }
              }
            }
          }
        }`,
        variables: {
          modelId,
          portfolioId,
          from: fetchStartDate,
          to: endDate,
          base: viewType === VIEW_TYPES.ACTIVE ? [base] : undefined,
        },
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    performanceDetails: getPerformanceDetails(state, props),
    firstDate: getFirstDate(state),
  }),
})
